import { useThemeObserver } from '@atlaskit/tokens';
import type { ThemeColorModes } from '@atlaskit/tokens';

/**
 * useThemeObserver returns colorMode:
 * - 'light', 'dark', 'auto' - when theming is properly initialized,
 *   meaning that window.AP.theming.initializeTheming() is called
 *   and the user uses theme other than 'original'
 * - undefined - otherwise and on the server
 */

export default function useThemeColorMode(): ThemeColorModes {
  const { colorMode: themeColorMode = 'light' } = useThemeObserver();

  return themeColorMode;
}
